import {email, helpers, required} from "@vuelidate/validators";

export const checkId = (value) => {
    let IDnum = String(value);
    if (IDnum.length > 9 || IDnum.length < 5) return false;
    if (!IDnum) return false;
    // The number is too short - add leading 0000
    if (IDnum.length < 9) {
        while (IDnum.length < 9) {
            IDnum = "0" + IDnum;
        }
    }
    // CHECK THE ID NUMBER
    let mone = 0,
        incNum;
    for (let i = 0; i < 9; i++) {
        incNum = Number(IDnum.charAt(i));
        incNum *= (i % 2) + 1;
        if (incNum > 9) incNum -= 9;
        mone += incNum;
    }

    // DIDNT WORK RIGHT
    return mone % 10 === 0;
};

export const isValidPhoneNumber = (value) => {
    // Check for non-numeric characters first
    let phoneValue = value;
    if (/\D/.test(phoneValue)) {
        return false;
    }

    if (phoneValue.length === 0) {
        return true;
    }

    phoneValue = `${phoneValue}`.replace(/\D/g, "");

    // Cellphone patterns: 5xyzzzzzz, 05xyzzzzzz, 05x-yzzzzzz, 9725xyzzzzzz, +9725xyzzzzzz
    const cellphonePatterns = [
        /^527629782$/,
        /^5[0-8]\d{6}$/,
        /^05[0-8]\d{7}$/,
        /^05[0-8]-\d{7}$/,
        /^9725[0-8]\d{6}$/,
        /^\+9725[0-8]\d{6}$/,
        /^05\d \d{3} \d{4}$/,
    ];

    // Landline patterns: xyzzzzzz, 0xyzzzzzz, 7tyzzzzzz, 07tyzzzzzz, 0x-yzzzzzz, 07x-yzzzzzz, 972xyzzzzzz, 9727tyzzzzzz, +972xyzzzzzz, +9727tyzzzzzz
    const landlinePatterns = [
        /^0[23489]\d{7}$/,
        /^[2-489]\d{7}$/,
        /^[2-489]\d{8}$/,
        /^0[2-489]\d{8}$/,
        /^0[2-489]\d{9}$/,
        /^7[1234679]\d{7}$/,
        /^07[1234679]\d{8}$/,
        /^0[2-489]-\d{7}$/,
        /^07[2-489]-\d{7}$/,
        /^972[2-489]\d{7}$/,
        /^9727[1234679]\d{7}$/,
        /^\+972[2-489]\d{7}$/,
        /^\+9727[1234679]\d{7}$/,
        /^\d{8}$/,
        /^0\d{9}$/,
    ];

    return (
        cellphonePatterns.some((pattern) => pattern.test(phoneValue)) ||
        landlinePatterns.some((pattern) => pattern.test(phoneValue))
    );
};

const validEmailCharacters = (value) => {
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return pattern.test(value);
};

const firstPhoneRequire = (phoneNumbers) => {
    const phones = phoneNumbers.filter(
        (item) => item.tel.toString().trim().length
    );
    return !!phones.length;
};

const userValidation = {
    idNumber: {
        required,
        checkId: helpers.withMessage("מספר זהות שגוי", checkId),
    },
    fname: {
        required,
    },
    lname: {
        required,
    },
    street: {},
    city: {},
    email: {
        required: helpers.withMessage('שכחתם לכתוב לנו את כתובת המייל שלכם', required),
        email: helpers.withMessage("יש פה טעות בכתובת מייל. תוכלו לכתוב מהתחלה?", email),
        validEmailCharacters: helpers.withMessage('משהו הסתבך. אפשר בינתיים ללכת לבדוק מה עוד צריך לקנות לבית ומיד אחר כך להרשם.', validEmailCharacters)
    },
    allPhoneNumbers: {
        firstPhoneRequire: helpers.withMessage(
            "At least 1 phone is required",
            firstPhoneRequire
        ),
        $each: helpers.forEach({
            tel: {
                isValidPhoneNumber: helpers.withMessage(
                    "מספר טלפון לא תקין",
                    isValidPhoneNumber
                ),
            },
        }),
    },
};

export {userValidation};
